import React, { useState, useEffect } from 'react';
import addToFavorites from "../assets/addToFavorites.png";
import favorite from "../assets/favorites.png";
import styles from "./FavoritesButton.module.css";
import { useSharedState } from '../hooks/useSharedState';

interface Props {
  eventId: number;
  className?: string;
  mode?: 'small' | 'fullText';
}

const FavoriteButton: React.FC<Props> = ({ eventId, className = '', mode = 'small' }) => {
  const [isFav, setIsFav] = useState(false);
  const [favorites, setFavorites] = useSharedState('favoriteEvents', '');

  const handleToggle = () => {
    const current = favorites;
    const favs = current ? JSON.parse(current) : [];

    let updated;
    if (favs.includes(eventId)) {
      updated = favs.filter((id: number) => id !== eventId);
      
    } else {
      updated = [...favs, eventId];
      
    }
    setFavorites(JSON.stringify(updated));
  };

  useEffect(() => {
    
    setIsFav(favorites && JSON.parse(favorites).includes(eventId))
    
  }, [favorites, eventId]);

  const actionLabel = isFav ? "Retirer de mes alentours" : "Ajouter à mes alentours";

  return (
    <button
        type="button"
        className={[
          styles.favoriteButton,
          mode === 'fullText' ? styles.fullText : styles.small,
          className
        ].filter(Boolean).join(' ')}
        aria-label={actionLabel}
        aria-pressed={isFav}
        title={actionLabel}
        onClick={handleToggle}
    >
        {mode === 'fullText' && <span className={styles.label}>{actionLabel}</span>}
        <div className={(isFav ? [styles.button, styles.selected] : [styles.button]).join(' ')}>
            <div className={styles.circle}></div>
            <div className={styles.outline}></div>
            <img src={isFav? favorite : addToFavorites} alt="favoris"/>
        </div>
    </button>
  );
};

export default FavoriteButton;
